export default function (vm) {
  return [
    { key: 'id', label: 'id' },
    { key: 'title', label: 'title' },
    {
      key: 'createdBy',
      label: 'createdBy',
      type: 'user',
      props: {
        clearable: true,
        multiple: false,
      }
    },
    {
      key: 'types',
      label: 'type',
      type: 'select',
      props: {
        options: [
          { value: 'NEW_FEATURE', label: 'New Feature' },
          { value: 'BUG', label: 'Bug' },
          { value: 'CLAIM', label: 'Claim' },
          { value: 'TASK', label: 'Task' },
        ],
        multiple: true,
        clearable: true,
      }
    },
    {
      key: 'statuses',
      label: 'status',
      type: 'select',
      props: {
        options: [
          { value: 'REQUEST', label: vm.$t("ticketStatuses.REQUEST")},
          { value: 'IN_PROGRESS', label: vm.$t("ticketStatuses.IN_PROGRESS") },
          { value: 'WAITING_FOR_USER_RESPONSE', label: vm.$t("ticketStatuses.WAITING_FOR_USER_RESPONSE") },
          { value: 'DONE', label: vm.$t("ticketStatuses.DONE") },
          { value: 'CANCELLED', label: vm.$t("ticketStatuses.CANCELLED") },
        ],
        reduce: option => option.value,
        multiple: true,
        clearable: true,
      },
      collapsed: true,
      collapsedMinWidth: "450px",
    },
    {
      key: 'priorities',
      label: 'priority',
      type: 'select',
      props: {
        options: [
          { value: 'LOW', label: vm.$t("priorityOptions.LOW") },
          { value: 'MEDIUM', label: vm.$t("priorityOptions.MEDIUM") },
          { value: 'HIGH', label: vm.$t("priorityOptions.HIGH") },
          { value: 'CRITICAL', label: vm.$t("priorityOptions.CRITICAL") },
        ],
        reduce: option => option.value,
        multiple: true,
        clearable: true,
      }
    },
    { key: 'creationTimeStart', label: 'from', type: 'date' },
    { key: 'creationTimeEnd', label: 'to', type: 'date' },
  ]
}
